'use client';

/**
 * Root ("/") analog of the partner layout's PartnerSdkRuntime mount. Reuses the exact
 * same Unity-free @sdk-mobile runtime (side menu + SDK singletons) the partner surface
 * uses, for signed-in vanilla-Skillz players.
 *
 * Two jobs the partner LAYOUT normally does (root has no dedicated layout — `/` shares
 * the global (app) layout — so the page mounts this instead):
 *  1. Set window.__SKILLZ_APP_GAME_ID__ = 19369 so getGameId() resolves the shell game
 *     for the @sdk-mobile module-load freeze. Done at THIS chunk's module scope, which
 *     evaluates before the dynamically-imported PartnerSdkRuntime chunk (and thus before
 *     any @sdk-mobile module) loads.
 *  2. Mount PartnerSdkRuntime (ssr:false). No partner theme overlay here — root uses the
 *     shell game's own (Skillz) theme, which is exactly what the raw settings carry.
 *
 * Only mounted for authenticated root visitors (guests get a sign-in pill, no runtime).
 */

import dynamic from 'next/dynamic';
import type {SDKSettings} from '@/app/(app)/sdk/[gid]/types';

if (typeof window !== 'undefined' && !window.__SKILLZ_APP_GAME_ID__) {
  window.__SKILLZ_APP_GAME_ID__ = '19369';
}

const PartnerSdkRuntime = dynamic(
  () => import('@/app/(app)/partner/[slug]/_src/PartnerSdkRuntime'),
  {ssr: false}
);

export default function RootMulticadeRuntime({
  settings,
  isAuthenticated,
  interstitials = false,
}: {
  settings: SDKSettings;
  isAuthenticated: boolean;
  /** Partner-console `interstitials` flag → fire the arcade interstitial trigger. */
  interstitials?: boolean;
}) {
  return (
    <PartnerSdkRuntime
      settings={settings}
      isAuthenticated={isAuthenticated}
      interstitials={interstitials}
    />
  );
}
